module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/social/instagram-fb0906913be5145a42c71542883687f2.svg";